export function getCellWidth(index, cellWidthArray) {
  return cellWidthArray[index % cellWidthArray.length]
}

export function getIsScrollButtonRow(index, rows) {
  return index === Math.floor(rows / 2)
}
